<template>
  <svg
    class="inline-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="3"
      y="6"
      width="18"
      height="13"
      stroke="#052E37"
      stroke-width="2"
      stroke-dasharray="2 2"
    />
  </svg>
</template>

<script lang="ts">
export default {};
</script>